"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const KeysService_1 = __importDefault(require("../KeysService"));
const randomBytes_1 = require("../../shared/randomBytes");
const defaultJoloContext_1 = require("./defaultJoloContext");
const keccak256 = require('keccak256');
class JoloDidDocument {
    constructor(keysService) {
        this._signingKey = 'keys-1';
        this._keysService = keysService;
    }
    _getDid(seedHex) {
        const publicKey = KeysService_1.default.getPublicKey(seedHex, 'jolo');
        const prefix = 'did:jolo:';
        const suffix = keccak256(publicKey);
        return prefix + suffix.toString('hex');
    }
    getMyDid() {
        const { seed } = this._keysService.decryptSeed();
        const seedHex = seed.toString('hex');
        return this._getDid(seedHex);
    }
    getKeyId(did = null) {
        if (!did) {
            did = this.getMyDid();
        }
        return `${did}#${this._signingKey}`;
    }
    buildDidDocument() {
        return __awaiter(this, void 0, void 0, function* () {
            const { seed } = this._keysService.decryptSeed();
            const seedHex = seed.toString('hex');
            const publicKey = KeysService_1.default.getPublicKey(seedHex, 'jolo');
            const did = this._getDid(seedHex);
            const keyId = `${did}#${this._signingKey}`;
            const nonce = yield randomBytes_1.randomBytes(8);
            return {
                '@context': defaultJoloContext_1.defaultContext,
                id: did,
                created: new Date().toISOString(),
                authentication: [keyId],
                assertionMethod: [keyId],
                publicKey: [
                    {
                        id: keyId,
                        controller: did,
                        type: 'Secp256k1VerificationKey2018',
                        publicKeyHex: publicKey.toString('hex'),
                    },
                ],
                proof: {
                    type: 'EcdsaKoblitzSignature2016',
                    created: new Date().toISOString(),
                    creator: keyId,
                    nonce: nonce.toString('hex'),
                    signatureValue: '',
                },
            };
        });
    }
}
exports.default = JoloDidDocument;
//# sourceMappingURL=JoloDidDocument.js.map